import { RefObject, useLayoutEffect } from 'react';

/** Kept outside React: the point is to survive the component being unmounted. */
const positions = new Map<string, number>();

/**
 * Remembers a scroll container's offset across unmounts.
 *
 * Every page renders its own ResponsiveLayout, so navigating tears the whole shell down and builds
 * a new one — which resets the menu's scroll to the top on every click. Restoring the offset before
 * paint (useLayoutEffect) makes that remount invisible.
 */
export const useScrollMemory = (ref: RefObject<HTMLElement>, key: string) => {
  useLayoutEffect(() => {
    const el = ref.current;
    if (!el) return;

    const saved = positions.get(key);
    if (saved) el.scrollTop = saved;

    const onScroll = () => positions.set(key, el.scrollTop);
    el.addEventListener('scroll', onScroll, { passive: true });
    return () => el.removeEventListener('scroll', onScroll);
  }, [ref, key]);
};

export default useScrollMemory;
